<div class="helpers-upload-main">
    <label [hidden]="title == ''">{{title}}</label>
    <div>
        <core-storage-files-upload
            [multiple]="true"
            [removed]="removed" 
            (response)="upload($event)"
            (onUploading)="onUploading($event)" 
            [hiddenUploaded]="true"
        ></core-storage-files-upload>

        <core-storage-file-uploaded-list-item 
            *ngFor="let file of files"
            [remove]="true" 
            (onRemove)="remove(file)" 
            [file]="file"
        ></core-storage-file-uploaded-list-item>
    </div>
</div>